<div class="profile-menu-container">
  <div class="user-profile-top-container">
    <div class="user-icon-container">
      <mat-icon class="user-icon extra-large-icon">assignment_ind</mat-icon>
    </div>
    <div class="user-info-container">
      <div class="user-name">{{ fullName() }}</div>
      <div class="user-role">{{ role() }}</div>
      <div class="user-email">
        <mat-icon class="user-icon small-icon">email</mat-icon>
        <div>{{ email() }}</div>
      </div>
    </div>
  </div>
  <div>
    <mat-divider class="profile-menu-divider"></mat-divider>
  </div>
  <!-- <div class="user-profile-middle-container">
    <div class="user-profile-middle-container-icon">
      <mat-icon class="user-icon">perm_identity</mat-icon>
    </div>
    <div class="user-profile-middle-container-text">
      My profile
    </div>
  </div> -->
  @if (!hideMessages) {
    <div class="user-profile-middle-container" (click)="goToMessages()">
      <div class="user-profile-middle-container-icon">
        <mat-icon class="user-icon">message</mat-icon>
      </div>
      <div class="user-profile-middle-container-text">
        Messages
      </div>
    </div>
  }
  <div class="user-profile-middle-container" (click)="changePassword()">
    <div class="user-profile-middle-container-icon">
      <mat-icon class="user-icon">password</mat-icon>
    </div>
    <div class="user-profile-middle-container-text">
      Change password
    </div>
  </div>
  <div class="user-profile-middle-container" (click)="openAbout()">
    <div class="user-profile-middle-container-icon">
      <mat-icon class="user-icon">info</mat-icon>
    </div>
    <div class="user-profile-middle-container-text">
      About
    </div>
  </div>
  <div>
    <mat-divider class="profile-menu-divider"></mat-divider>
  </div>
  <div class="user-profile-bottom-container">
    <button mat-flat-button class="nrg-secondary-flat-button logout-button" (click)="logout()">
      <mat-icon>logout</mat-icon>
      Logout
    </button>
  </div>
</div>
